export default "__VITE_ASSET__OYlJxkOI__"